import { render, staticRenderFns } from "./DiscountMessage.vue?vue&type=template&id=0728b5dd&scoped=true"
import script from "./DiscountMessage.vue?vue&type=script&lang=js"
export * from "./DiscountMessage.vue?vue&type=script&lang=js"
import style0 from "./DiscountMessage.vue?vue&type=style&index=0&id=0728b5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0728b5dd",
  null
  
)

export default component.exports